// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-holding {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}

/* Subheader (title + meta, underlined) */
.top-holding__subheader {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  gap: 8px;
  width: 100%;
  padding-bottom: 8px;
  box-shadow: inset 0 -1px 0 var(--border-line);
  background-color: var(--surface-primary);
}

.top-holding__subheader-title {
  flex: 1 0 0;
  min-width: 0;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
}

.top-holding__subheader-meta {
  flex-shrink: 0;
  text-align: right;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
}

/* Holdings list */
.top-holding__list {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 7px;
  min-height: 0;
  width: 100%;
  padding-top: 8px;
}

.top-holding__item {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 4px;
  width: 100%;
}

.top-holding__labels {
  display: flex;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

/* Wrapper owns the flex sizing + overflow clipping so the ellipsis element
   itself is a plain, fully-constrained block. This keeps text-overflow
   reliable even though the inner span is cloned/ref'd by MUI Tooltip. */
.top-holding__name-wrap {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

.top-holding__name {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-holding__weight {
  flex-shrink: 0;
  width: 64px;
  text-align: right;
}

.top-holding__bar {
  position: relative;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: var(--surface-secondary);
  overflow: hidden;
}

.top-holding__bar-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 2px;
  background-color: var(--chart-primary);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/TopHolding/TopHolding.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;wEAEwE;AACxE;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC","sourcesContent":[".top-holding {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  width: 100%;\n}\n\n/* Subheader (title + meta, underlined) */\n.top-holding__subheader {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  gap: 8px;\n  width: 100%;\n  padding-bottom: 8px;\n  box-shadow: inset 0 -1px 0 var(--border-line);\n  background-color: var(--surface-primary);\n}\n\n.top-holding__subheader-title {\n  flex: 1 0 0;\n  min-width: 0;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n}\n\n.top-holding__subheader-meta {\n  flex-shrink: 0;\n  text-align: right;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n}\n\n/* Holdings list */\n.top-holding__list {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 7px;\n  min-height: 0;\n  width: 100%;\n  padding-top: 8px;\n}\n\n.top-holding__item {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  gap: 4px;\n  width: 100%;\n}\n\n.top-holding__labels {\n  display: flex;\n  align-items: flex-start;\n  gap: 2px;\n  width: 100%;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n/* Wrapper owns the flex sizing + overflow clipping so the ellipsis element\n   itself is a plain, fully-constrained block. This keeps text-overflow\n   reliable even though the inner span is cloned/ref'd by MUI Tooltip. */\n.top-holding__name-wrap {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.top-holding__name {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.top-holding__weight {\n  flex-shrink: 0;\n  width: 64px;\n  text-align: right;\n}\n\n.top-holding__bar {\n  position: relative;\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  background-color: var(--surface-secondary);\n  overflow: hidden;\n}\n\n.top-holding__bar-fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  border-radius: 2px;\n  background-color: var(--chart-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
